// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Forms/AdminPortal/Brand/Brand.css */

.brand-container {
    max-width: 1200px;
    margin: auto;
}

.brand-container h2 {
    color: #364C63;
    font-size: 1.5rem;
    text-transform: uppercase;
}

.add-brand-btn {
    background-color: #1976d2;
    color: white;
    border: none;
    padding: 5px 7.5px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.3s;
}

.add-brand-btn:hover {
    background-color: #2980b9;
}

.brand-form {
    padding: 1rem;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 2px;
}

.brand-form h3 {
    color: #364C63;
    margin-bottom: 5px;
    font-size: 18px;
}

.formm-section {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;
}

.form-rowww {
    display: flex;
    margin-bottom: 5px;
    width: 100%;
}

.form-groupppp {
    flex: 1 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
}

.form-groupppp label {
    font-size: 14px;
    font-weight: 500;
    color: #2c3e50;
    min-width: 120px;
    text-align: right;
}

.form-groupppp .input-container {
    flex: 1 1;
    display: flex;
    position: relative;
}

.form-groupppp input,
.form-groupppp textarea {
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 12px;
    width: 100%;
}

.form-groupppp textarea {
    resize: vertical;
}

.form-groupppp input:focus,
.form-groupppp textarea:focus {
    outline: none;
    border-color: #3498db;
    box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
}

.brand-list {
    width: 100%;
    margin-top: 1rem;
    overflow: hidden;
}

.brand-list-title {
    text-align: center;
    margin-bottom: 1rem;
    margin-top: 1rem;
    color: #2c3e50;
    font-size: 1.25rem;
}

.brand-cards-container {
    display: flex;
    flex-wrap: nowrap;
    gap: 10px;
    padding: 10px;
    overflow-x: auto;
    scrollbar-width: thin;
    scrollbar-color: #90A4AE #CFD8DC;
    -webkit-overflow-scrolling: touch;
}

.brand-cards-container::-webkit-scrollbar {
    height: 8px;
}

.brand-cards-container::-webkit-scrollbar-track {
    background: #CFD8DC;
    border-radius: 4px;
}

.brand-cards-container::-webkit-scrollbar-thumb {
    background-color: #90A4AE;
    border-radius: 4px;
}

.brand-cards-container::-webkit-scrollbar-thumb:hover {
    background-color: #78909C;
}

.brand-card {
    background-color: #eef7ff8f;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    padding: 10px;
    transition: transform 0.3s;
    flex: 0 0 auto;
    width: 350px;
}

.brand-card:hover {
    transform: translateY(-2px);
}

.brand-card .brand-info h3 {
    color: #EF6F53;
    margin: 0 0 10px 0;
    font-size: 18px;
    font-weight: bold;
}

.brand-info p {
    margin: auto;
    color: #2c3e50;
    font-size: 14px;
    text-align: left;
}

.brand-actions {
    display: flex;
    gap: 10px;
    margin-top: 15px;
}

.brand-actions button {
    padding: 6px 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 13px;
    transition: background-color 0.3s;
}

.brand-actions button:first-child {
    background-color: #3498db;
    color: white;
}

.brand-actions button:first-child:hover {
    background-color: #2980b9;
}

.brand-actions button:last-child {
    background-color: #e74c3c;
    color: white;
}

.brand-actions button:last-child:hover {
    background-color: #c0392b;
}

.error-message {
    background-color: #fce4e4;
    border: 1px solid #fcc2c3;
    color: #cc0033;
    padding: 1px;
    border-radius: 4px;
    width: fit-content;
    margin:  5px auto;
    font-size: 14px;
}

.success-message {
    background-color: #d4edda;
    border: 1px solid #c3e6cb;
    color: #155724;
    padding: 1px;
    border-radius: 4px;
    width: fit-content;
    margin:  5px auto;
    font-size: 14px;
}

.loading {
    text-align: center;
    padding: 20px;
    color: #666;
    font-size: 16px;
}

.forrm-actions {
    display: flex;
    gap: 5px;
    justify-content: center;
}

.forrm-actions button {
    padding: 5px 7.5px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s ease;
}

.forrm-actions button[type="submit"] {
    background-color: #2ecc71;
    color: white;
}

.forrm-actions button[type="submit"]:hover {
    background-color: #27ae60;
}

.forrm-actions button[type="button"] {
    background-color: #e74c3c;
    color: white;
}

.forrm-actions button[type="button"]:hover {
    background-color: #c0392b;
}

.forrm-actions button:active {
    transform: scale(0.98);
}

`, "",{"version":3,"sources":["webpack://./src/components/routes/Forms/AdminPortal/Brand/Brand.css"],"names":[],"mappings":"AAAA,4DAA4D;;AAE5D;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,kBAAkB;AACtB;;AAEA;;IAEI,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,SAAS;IACT,aAAa;IACb,gBAAgB;IAChB,qBAAqB;IACrB,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,0BAA0B;IAC1B,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":["/* src/components/routes/Forms/AdminPortal/Brand/Brand.css */\n\n.brand-container {\n    max-width: 1200px;\n    margin: auto;\n}\n\n.brand-container h2 {\n    color: #364C63;\n    font-size: 1.5rem;\n    text-transform: uppercase;\n}\n\n.add-brand-btn {\n    background-color: #1976d2;\n    color: white;\n    border: none;\n    padding: 5px 7.5px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n    transition: background-color 0.3s;\n}\n\n.add-brand-btn:hover {\n    background-color: #2980b9;\n}\n\n.brand-form {\n    padding: 1rem;\n    border-radius: 10px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    margin-bottom: 2px;\n}\n\n.brand-form h3 {\n    color: #364C63;\n    margin-bottom: 5px;\n    font-size: 18px;\n}\n\n.formm-section {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    width: 100%;\n}\n\n.form-rowww {\n    display: flex;\n    margin-bottom: 5px;\n    width: 100%;\n}\n\n.form-groupppp {\n    flex: 1;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 5px;\n}\n\n.form-groupppp label {\n    font-size: 14px;\n    font-weight: 500;\n    color: #2c3e50;\n    min-width: 120px;\n    text-align: right;\n}\n\n.form-groupppp .input-container {\n    flex: 1;\n    display: flex;\n    position: relative;\n}\n\n.form-groupppp input,\n.form-groupppp textarea {\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 12px;\n    width: 100%;\n}\n\n.form-groupppp textarea {\n    resize: vertical;\n}\n\n.form-groupppp input:focus,\n.form-groupppp textarea:focus {\n    outline: none;\n    border-color: #3498db;\n    box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);\n}\n\n.brand-list {\n    width: 100%;\n    margin-top: 1rem;\n    overflow: hidden;\n}\n\n.brand-list-title {\n    text-align: center;\n    margin-bottom: 1rem;\n    margin-top: 1rem;\n    color: #2c3e50;\n    font-size: 1.25rem;\n}\n\n.brand-cards-container {\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 10px;\n    padding: 10px;\n    overflow-x: auto;\n    scrollbar-width: thin;\n    scrollbar-color: #90A4AE #CFD8DC;\n    -webkit-overflow-scrolling: touch;\n}\n\n.brand-cards-container::-webkit-scrollbar {\n    height: 8px;\n}\n\n.brand-cards-container::-webkit-scrollbar-track {\n    background: #CFD8DC;\n    border-radius: 4px;\n}\n\n.brand-cards-container::-webkit-scrollbar-thumb {\n    background-color: #90A4AE;\n    border-radius: 4px;\n}\n\n.brand-cards-container::-webkit-scrollbar-thumb:hover {\n    background-color: #78909C;\n}\n\n.brand-card {\n    background-color: #eef7ff8f;\n    border-radius: 5px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    padding: 10px;\n    transition: transform 0.3s;\n    flex: 0 0 auto;\n    width: 350px;\n}\n\n.brand-card:hover {\n    transform: translateY(-2px);\n}\n\n.brand-card .brand-info h3 {\n    color: #EF6F53;\n    margin: 0 0 10px 0;\n    font-size: 18px;\n    font-weight: bold;\n}\n\n.brand-info p {\n    margin: auto;\n    color: #2c3e50;\n    font-size: 14px;\n    text-align: left;\n}\n\n.brand-actions {\n    display: flex;\n    gap: 10px;\n    margin-top: 15px;\n}\n\n.brand-actions button {\n    padding: 6px 12px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 13px;\n    transition: background-color 0.3s;\n}\n\n.brand-actions button:first-child {\n    background-color: #3498db;\n    color: white;\n}\n\n.brand-actions button:first-child:hover {\n    background-color: #2980b9;\n}\n\n.brand-actions button:last-child {\n    background-color: #e74c3c;\n    color: white;\n}\n\n.brand-actions button:last-child:hover {\n    background-color: #c0392b;\n}\n\n.error-message {\n    background-color: #fce4e4;\n    border: 1px solid #fcc2c3;\n    color: #cc0033;\n    padding: 1px;\n    border-radius: 4px;\n    width: fit-content;\n    margin:  5px auto;\n    font-size: 14px;\n}\n\n.success-message {\n    background-color: #d4edda;\n    border: 1px solid #c3e6cb;\n    color: #155724;\n    padding: 1px;\n    border-radius: 4px;\n    width: fit-content;\n    margin:  5px auto;\n    font-size: 14px;\n}\n\n.loading {\n    text-align: center;\n    padding: 20px;\n    color: #666;\n    font-size: 16px;\n}\n\n.forrm-actions {\n    display: flex;\n    gap: 5px;\n    justify-content: center;\n}\n\n.forrm-actions button {\n    padding: 5px 7.5px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: all 0.3s ease;\n}\n\n.forrm-actions button[type=\"submit\"] {\n    background-color: #2ecc71;\n    color: white;\n}\n\n.forrm-actions button[type=\"submit\"]:hover {\n    background-color: #27ae60;\n}\n\n.forrm-actions button[type=\"button\"] {\n    background-color: #e74c3c;\n    color: white;\n}\n\n.forrm-actions button[type=\"button\"]:hover {\n    background-color: #c0392b;\n}\n\n.forrm-actions button:active {\n    transform: scale(0.98);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
